import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import'@fortawesome/react-fontawesome'
import { faPhoneAlt,faMapMarkedAlt,faEnvelope} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF,faInstagram,faYoutube  ,faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
function Footer()
{
    const currentYear = new Date().getFullYear() ;
    return(
    
        <div className="footer">
                <div className="container">
                <div className="row">
                <div className="col-md-6 col-lg-3">
                <div className="footer-contact">
                <h2>Get In Touch</h2>
                <p  ><i className="fa fa-map-marker-alt" icon={faMapMarkedAlt} ></i>Tunis, Tunisia</p>
                <p  ><i className="fa fa-phone-alt" icon={faPhoneAlt} ></i>+216 53 266 284 <br/>+216 95 531 748 </p>
                <p  ><i className="fa fa-envelope" icon={faEnvelope} ></i>pemi.tunisia@gmail.com </p>
                <div className="footer-social">
               
                <a href="https://www.facebook.com/PEMI.Tunisia"><i className="fab fa-facebook-f" icon={faFacebookF} ></i></a>
                <a href="/"><i className="fab fa-youtube" icon={faYoutube} ></i></a>
                <a href="/"><i className="fab fa-instagram" icon={faInstagram} ></i></a>
                <a href="/"><i className="fab fa-linkedin-in" icon={faLinkedinIn} ></i></a>
                </div>
                </div>
                </div>
                <div className="col-md-6 col-lg-3">
                <div className="footer-link">
                <h2>Useful Link</h2>
                <a  href="/">Home</a>
                <a  href="/maintenance">Maintenance</a>
                <a  href="/energie-renouvable#Photovoltaïque-BT">Solar Energy</a>
                <a  href="/energie-renouvable#efficacité-énergétique">Energy Audit</a>
                 <a href="/energie-renouvable#efficacité-énergétique">Measurement and Verification M&V</a>
                <a  href="/maintenance#Domaines-d’intervention">BMS/GTB/GTC</a>
                </div>
                </div>
                <div className="col-md-6 col-lg-3">
                <div className="footer-link">
                <h2>Useful Link</h2>
                <a  href="/Environment">Waste & Water Treatment </a>
                <a  href="/Environment">Smart Agriculture </a>
                <a  href={"/management#accompagnement-iso-9001"}>Quality Management System</a>
                <a  href={"/management#accompagnement-iso-45001"}>Health & Safety</a>
                <a  href={"/energie-renouvable#efficacité-énergétique"}>Energy Management</a>
                <a  href={"/management#accompagnement-IATF-16949"}>Assistance  IATF 16949</a>
                </div>
                </div>
                <div className="col-md-6 col-lg-3">
                <div className="footer-form">
                <h2>NEWSLETTER</h2>
                
                <input className="form-control" placeholder="Email here"/>
                <button className="btnn">Submit</button>
                </div>
                </div>
                </div>
                </div>
                <div className="container copyright">
                <div className="row">
                <div className="col-md-6" >
                <p >Copyright ⓒ {currentYear}, All Right Reserved.</p>
                </div>
               
                </div>
                </div>
             </div>
             
        
    
    );

}
export default Footer ;